import { start } from './index'

const init = () => {
  start()
}

init()
